$.fn.bindInView = function(callback) {
    // Function to handle the visibility of the target element
    function handleIntersection(entries) {
        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            var isInView = entry.isIntersecting;
            callback.call(entry.target, null, isInView); // Call the provided callback with the element and visibility
        }
    }

    // Create an Intersection Observer instance
    var observer = new IntersectionObserver(handleIntersection, {
        root: null, // Use the viewport as the root
        threshold: 0.1 // Trigger when 10% of the element is visible
    });

    // Observe each element in the jQuery object
    this.each(function() {
        observer.observe(this); // 'this' refers to the current DOM element
    });

    return this; // Maintain jQuery chaining
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/vendors/jquery-inview.js
// module id = 111
// module chunks = 0